import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9db11e40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-item" }
const _hoisted_2 = { class: "step-item_header" }
const _hoisted_3 = {
  key: 0,
  class: "step-item_header_line"
}
const _hoisted_4 = { class: "step-item_container_header" }
const _hoisted_5 = { class: "step-item_container_header_main_title" }
const _hoisted_6 = {
  key: 0,
  class: "step-item_container_header_sub_title"
}
const _hoisted_7 = { class: "review-time" }
const _hoisted_8 = { class: "step-item_container_detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 审核意见: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 审核单位: ", -1))
const _hoisted_11 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["step-item_header_icon", _ctx.icon])
      }, [
        _createVNode(_component_BaseIcon, { name: _ctx.icon }, null, 8, ["name"])
      ], 2),
      (!_ctx.isLast)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["step-item_container", ['is-' + _ctx.currentStatus]])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
          (_ctx.times)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 第" + _toDisplayString(_ctx.times) + "次返回修改或重置流程 ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.datetime), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _hoisted_9,
          _createElementVNode("span", {
            class: _normalizeClass(["content", { result: _ctx.currentStatus == 'error' }])
          }, _toDisplayString(_ctx.message), 3)
        ]),
        _createElementVNode("p", null, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.description), 1)
        ])
      ])
    ], 2)
  ]))
}